import React from 'react'

const Pengguna = React.lazy(() => import('./Pengguna'))
// const HakAkses = React.lazy(() => import('./HakAkses'))
// const TambahHakAkses = React.lazy(() => import('./HakAkses/TambahHakAkses'))

export const pengaturanConfigs = [
    // {
    //     path: '/pengaturan/hak-akses',
    //     element: <HakAkses />,
    //     permittedRole: ['Operator', 'Operator Eselon 1', 'Administrator', 'Viewer']
    // },
    // {
    //     path: '/pengaturan/hak-akses/tambah',
    //     element: <TambahHakAkses />,
    //     permittedRole: ['Operator', 'Operator Eselon 1', 'Administrator']
    // },
    {
        path: '/pengaturan/pengguna',
        element: <Pengguna />,
        permittedRole: ['Operator', 'Operator Eselon 1', 'Administrator', 'Viewer']
    },
]